<script>
import {
  ArrowUpIcon,
} from "vue-feather-icons";
import appConfig from "@/app.config";
import axios from 'axios';

// 초기세팅
function initialState() {
  return {
    token: "",
    login: {
      idx: 0,
      level: 0,
      nick: "",
      isLogin: false,
    },
    fields: [
      {key: 'idx', label: 'idx', thClass: 'col-2 text-center font-size-11', tdClass: 'col-2 text-center'},
      {key: 'newName', label: '새게시판 이름', thClass: 'text-center font-size-11', tdClass: 'text-center'},
      {key: 'new', label: '새 게시판 코드', thClass: 'col-2 text-center font-size-11', tdClass: 'col-1 text-center'},
      {key: 'old', label: '구 게시판 코드', thClass: 'col-2 text-center font-size-11', tdClass: 'col-1 text-center'},
      {key: 'oldLastIdx', label: '구 마지막 가져온글', thClass: 'col-2 text-center font-size-11', tdClass: 'col-1 text-center'},
      {key: 'btn', label: '가져오기', thClass: 'col-2 text-center font-size-11', tdClass: 'col-1 text-center'},
    ],
    converterList: [],
  };
}

export default {
  components: {
    ArrowUpIcon,
  },
  data() {
    return initialState();
  },
  props: {
    selectedMenu: {
      type: String,
    },
  },
  computed: {
  },
  mounted() {
  },
  created() {
    this.first()
  },
  methods: {
    first() {
      let getLocalStorage = JSON.parse(localStorage.getItem('user'))
      if (getLocalStorage) {
        this.login.idx = getLocalStorage.idx
        this.login.nick = getLocalStorage.nick
        this.login.level = getLocalStorage.level
        this.token = getLocalStorage.token
        // 레벨 98 이하거나 로그인 안한상태면 첫화면으로
        if (this.login.level < 98) {
          this.$notify({ type: 'error', duration: 2000, title: '실패', text: '관리자 권한이 없습니다.' })
          this.$router.push('/');
        } else {
          this.getConverterList()
        }
      } else {
        this.$notify({ type: 'error', duration: 2000, title: '실패', text: '관리자 권한이 없습니다.' })
        this.$router.push('/');
      }
    },
    getConverterList() {
      try {
        axios({
          method: 'POST',
          url: appConfig.fastapi + '/auth/get_converter_list',
          headers: {
            'access-token': this.token
          },
          data: {
            "mb_id": this.login.idx,
          },
        })
        .then((res) => {
          if (res.data.type == 'success') {
            this.converterList = res.data.converterList;
          }
        })
        .catch((error) => {
          console.log(error)
          if (error.response) {
            this.$notify({ type: 'error', duration: 3000, 'title': error.response.status+' 에러', text: error.response.data.detail })
          }
        })
      } catch (error) {
        this.$notify({ type: 'error', duration: 3000, title: '실패', text: '요청 중 에러 발생 관리자에게 문의'+error })
      }
    },
    async startConverter(val) {
      this.loadingBar(true);
      try {
        await axios({
          method: 'POST',
          url: appConfig.fastapi + '/auth/start_convert',
          headers: {
            'access-token': this.token
          },
          data: {
            "idx": val,
          },
        })
        .then((res) => {
          if (res.data.type == 'success') {
            //this.converterList = res.data.converterList;
          }
        })
        .catch((error) => {
          console.log(error)
          if (error.response) {
            this.$notify({ type: 'error', duration: 3000, 'title': error.response.status+' 에러', text: error.response.data.detail })
          }
        })
      } catch (error) {
        this.$notify({ type: 'error', duration: 3000, title: '실패', text: '요청 중 에러 발생 관리자에게 문의'+error })
      } finally {
        this.loadingBar(false);
        this.getConverterList() // 컨버터 리스트 다시가져오자
      }
    },
    // 기다려주세요 loading 처리
    loadingBar(val) {
      if (val === true) {
        document.getElementById("preloader").style.display = "block";
        document.getElementById("status").style.display = "block";
      } else {
        document.getElementById("preloader").style.display = "none";
        document.getElementById("status").style.display = "none";
      }
    },
  },
}
</script>

<template>
  <div class="rounded shadow">
    <div class="p-4 border-bottom">
      <h5 class="text-md-left text-center">구홈피 이전</h5>
      <div class="text-center">
        26-01-09 작업완료되어 본 메뉴 더이상 이전작업 진행안함
      </div>
      <div>
        <div class="row mt-4">

          <div class="col-12 pt-2">
            <div class="rounded shadow">
              <div class="card mb-2">
                <div class="card-body p-2 font-size-13 text-bold">
                  <div>1. 구홈피 게시판이랑 새홈피 게시판이랑 연결하는거 미리 선언해서 DB에 준비해주자</div>
                  <div class="text-danger">new_from_old 테이블에 newName, new, old, oldLastIdx 컬럼 생성완료</div>
                  <div>2. 연결 선언된 리스트 짝지끼리 리스트 밑에 나오게 처리 (현재상태도 나오게)</div>
                  <div class="text-danger">작업완료</div>
                  <div>3. 리스트에서 이전시키기 누르면 백엔드로 정보전달</div>
                  <div class="text-danger">작업완료</div>
                  <div>4. 백엔드에서 이전작업 처리 (마지막 작업정보 디비에 게시판 마지막 번호 어딘가 남겨야됨)</div>
                  <div class="text-danger">게시물 가져오기 완료 (파일 이전 해야됨)</div>
                  <div> * 파일 이전작업 해야됨 (실파일명 경로에서 cp 후에 암호화파일명으로 만들 save 시키고)</div>
                  <div> * img 파일이라면 본문 최상단에 img태그붙여서 넣고 썸네일 이미지도 생성되게 처리</div>
                </div>
              </div>
            </div>
          </div>

          <div class="col-12 pt-2">
            <div class="rounded shadow">

              <div class="">
                <div class="table table-sm table-responsive font-size-14">
                  <b-table 
                    id="cordingHistoryTable" 
                    ref="cordingHistoryTable" 
                    :fields="fields" 
                    :items="converterList" 
                    :hover="true"
                    table-class="">
                    <template #cell(idx)="row">
                      <div class="badge text-secondary bg-white font-size-10">
                        {{ row.item.idx }}
                      </div>
                    </template>
                    <template #cell(newName)="row">
                      <div class="badge text-dark bg-white font-size-11">
                        {{ row.item.newName }}
                      </div>
                    </template>
                    <template #cell(new)="row">
                      <div class="badge text-dark bg-white font-size-11">
                        {{ row.item.new }}
                      </div>
                    </template>
                    <template #cell(old)="row">
                      <div class="badge text-dark bg-white font-size-11">
                        {{ row.item.old }}
                      </div>
                    </template>
                    <template #cell(oldLastIdx)="row">
                      <div class="badge text-dark bg-white font-size-11">
                        {{ row.item.oldLastIdx }}
                      </div>
                    </template>
                    <template #cell(btn)="row">
                      <div class="badge text-dark bg-white font-size-11">
                        <b-button @click="startConverter(row.item.idx)" class="btn btn-sm btn-primary">가져오기</b-button>
                      </div>
                    </template>
                  </b-table>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>